import { api } from '@/utils/api';

export const useRevalidatingAfterRun = () => {
  const utils = api.useUtils();
  const revalidate = () => {
    void utils.steps.paginated.invalidate()
    // void utils.steps.nextStep.invalidate()
    void utils.cadence.fetchPaginatedExecutables.invalidate()
    void utils.contact.responded.invalidate()
    void utils.globalReminder.paginated.invalidate()
    void utils.contact.contentViewed.invalidate()
  }
  return revalidate;
};